import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import { UniverseComponent } from 'src/domains/common/universes';

export const QuickHeaderBetsIcon = observer('QuickHeaderBetsIcon', (): JSX.Element => {
    return <UniverseComponent>{(universeModule): React.ReactElement => <universeModule.betsIcon />}</UniverseComponent>;
});
